import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Grid, Link, Picture, Text } from "~/components-shared";
import { useSelector } from "react-redux";
import { AuthoritiesEnum, RoutesEnum } from "~/types/enums";
import { useHistory } from "react-router-dom";
import authSelectors from "~/store/auth/selectors";
import styled, { useTheme } from "styled-components";
import lists from "~/lib/lists";
import useAbacExt from "~/hooks/abac";
import TopicFootprintContent from "~/components/TopicFootprintContent";
import ErrorBoundaryCard from "../ErrorBoundaryCard";
const Timeline = styled.div`
  position: relative;
  width: 6px;
  left: 50%;
  height: 100%;
  cursor: pointer;

  &:before {
    content: "";
    position: absolute;
    width: 2.4rem;
    height: 2.4rem;
    background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background.primary;
}};
    border-radius: 50%;
    left: -1rem;
    top: 0.35rem;
    z-index: 1;
  }

  &:after {
    content: "";
    position: absolute;
    width: 2px;
    height: 10000px;
    background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.borders.primary;
}};
    right: 2px;
    top: 2rem;
    margin-top: -2px;
  }
`;
const SourcePicture = styled(Picture)`
  position: absolute;
  top: 0.8rem;
  left: calc(3px - 0.75rem);
  z-index: 1;
`;
const Content = styled.div`
  overflow: hidden;
`;
const TopicFootprintSmall = _ref3 => {
  let {
    footprint,
    ...rest
  } = _ref3;
  const theme = useTheme();
  const user = useSelector(authSelectors.getUser);
  const history = useHistory();
  const {
    userHas
  } = useAbacExt();
  const handleMember = id => {
    history.push(user.id === id ? RoutesEnum.PROFILE : RoutesEnum.MEMBER.replace(":memberId", id));
  };
  return /*#__PURE__*/React.createElement(Grid, _extends({
    cols: 4,
    gap: 6,
    template: "2.5rem 1fr",
    fullWidth: true
  }, rest), /*#__PURE__*/React.createElement(Timeline, {
    className: "topic__footprint-timeline",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-float": true,
    "data-tooltip-content": lists.common.apps.names[footprint.source]
  }, /*#__PURE__*/React.createElement(SourcePicture, {
    border: "squared",
    src: lists.common.apps.logos(theme)[footprint.source],
    width: "1.5rem",
    height: "1.5rem",
    backgroundSize: "contain"
  })), /*#__PURE__*/React.createElement(Grid.Cell, {
    s: {
      mb: 6
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 2,
    template: userHas(AuthoritiesEnum.TOPICS_WRITE) ? "1fr auto" : "1fr",
    s: {
      mr: 2
    }
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, user?.id === footprint.createdBy.id ? /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold"
  }, footprint.createdBy.firstName, " ", footprint.createdBy.lastName) : /*#__PURE__*/React.createElement(Link, {
    weight: "semiBold",
    color: theme.colors.text.primary,
    onClick: () => handleMember(footprint.createdBy.id),
    underline: true
  }, footprint.createdBy.firstName, " ", footprint.createdBy.lastName), /*#__PURE__*/React.createElement(Content, {
    className: "search-content"
  }, /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, /*#__PURE__*/React.createElement(TopicFootprintContent, {
    footprint: footprint
  })))))));
};
export default TopicFootprintSmall;